
export default () => {

    const input = document.querySelector('#mobile')
    if(!input) return

    input.addEventListener('change', () => {
        let method = input.checked ? 'add' : 'remove'
        document.body.classList[method]('mobile-menu-active')
    })
}
